import { IServiceMetadata, IServiceRequest, ServiceRequestStatus } from "../models"

import { FC } from "react"
import { ServiceReqHelper } from "../helpers/helper"
import { ServiceRequestWizard } from "./ServiceRequestWizard"
import { ViewServiceRequest } from "./ViewServiceRequest"
import { useServiceRequestContext } from "./ServiceRequestContext"

interface IEditServiceRequestProps {
    submitLabel?: string,
    entity?: string,
    enableSubmit?: boolean,
    enableApproval?: boolean,
    relativePath?: string,
    documentsOnly: boolean,
    metadata?: IServiceMetadata,
    hideHeader?: boolean,
    hideTitle?: boolean,
    changeStatus?: boolean,
    enableResend?: boolean,
    isSendingForApproval?: boolean,
    onComplete: (requestId: string) => void,
    onCancel: (requestId: string) => void
}

export const EditServiceRequest: FC<IEditServiceRequestProps> = ({
    submitLabel, enableSubmit, enableApproval, entity, relativePath,
    documentsOnly, hideHeader, hideTitle, changeStatus, metadata,
    enableResend,isSendingForApproval, onComplete, onCancel
}) => {
    const { result } = useServiceRequestContext()
    const { serviceRequest } = result || {}

    const renderServiceRequest = (metadata: IServiceMetadata, serviceRequest: IServiceRequest) => {
        if (documentsOnly && serviceRequest.statusCode && (serviceRequest.statusCode === ServiceRequestStatus.Draft || serviceRequest?.statusCode !== ServiceRequestStatus.NotInitiated)) {
            return <></>
        }

        if (serviceRequest.statusCode && serviceRequest.statusCode !== ServiceRequestStatus.Draft && serviceRequest?.statusCode !== ServiceRequestStatus.NotInitiated) {
            return <ViewServiceRequest
                metadata={metadata!}
                documentsOnly={documentsOnly}
                isSendingForApproval={isSendingForApproval}
                entity={entity}
                enableSubmit={enableSubmit}
                enableApproval={enableApproval}
                relativePath={relativePath}
                hideHeader={hideHeader}
                hideTitle={hideTitle}
                enableResend={enableResend}
                values={ServiceReqHelper.values(serviceRequest.attributes || [], metadata!)}
                onCancel={onCancel} />
        }

        return <ServiceRequestWizard
            submitLabel={submitLabel}
            request={serviceRequest}
            metadata={metadata}
            entity={entity}
            relativePath={relativePath}
            hideHeader={hideHeader}
            hideTitle={hideTitle}
            changeStatus={changeStatus}
            onComplete={onComplete}
            initValues={ServiceReqHelper.values(serviceRequest.attributes || [], metadata)}
            schemas={ServiceReqHelper.schema(metadata)} />
    }

    return <>
        {(serviceRequest && metadata) && <>
            {renderServiceRequest(metadata, serviceRequest)}
        </>}
    </>
}